module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-500-medium-italic-8e89d5c4c03548eb8fcc6d6a1fdeea67.woff";